import { render, staticRenderFns } from "./prediction_stats.vue?vue&type=template&id=7935d7b0&"
import script from "./prediction_stats.vue?vue&type=script&lang=js&"
export * from "./prediction_stats.vue?vue&type=script&lang=js&"
import style0 from "./prediction_stats.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports